









































import { Component, Vue } from "vue-property-decorator";
import { Periode } from "../models/Periode";
import moment from "moment";
import store, { modules } from "../store";
import {
  MMessage,
  MDropdown,
  MDropdownItem,
  MSpinner,
  MPanel,
} from "@ulaval/modul-components";
import { TypeClientele } from "../models/TypeClientele";
import BoutonsNavigation from "../components/BoutonsNavigation.vue";

@Component({
  components: {
    MMessage,
    MDropdown,
    MDropdownItem,
    MSpinner,
    BoutonsNavigation,
    MPanel,
  },
})
export default class vuePeriode extends Vue {
  private chargementEnCours: boolean = true;

  private dateDebut: string = "";
  private dateFin: string = "";

  private async mounted(): Promise<void> {
    store.commit(modules.trainProgression.mutations.activerPrecedent.name);

    try {
      await store.dispatch(modules.cds.actions.recupererPeriodes.name, {
        typePeriodeId: this.typeClienteleSelectionne?.typePeriodeId,
        vm: this,
      });

      // Dans le cas où l'utilisateur avait déjà une sélection
      if (this.periodeSelectionne !== "") {
        store.commit(modules.trainProgression.mutations.activerSuivant.name);
      }
    } catch (e) {
      store.commit(modules.cds.mutations.recupererPeriodesEchec.name);
      store.commit(modules.utilisateur.mutations.sauvegarderPeriode.name, null);

      store.commit(
        modules.applicatif.mutations.modifierMessageErreur.name,
        store.state.applicatif.messageErreurParDefaut
      );
    }

    this.chargementEnCours = false;
  }

  private sauvegarderPeriode(periode: Periode): void {
    store.commit(
      modules.utilisateur.mutations.sauvegarderPeriode.name,
      periode
    );
  }

  get periodeSelectionne(): string {
    return store.state.utilisateur.periode?.id || "";
  }

  set periodeSelectionne(idPeriode: string) {
    if (this.periodeSelectionne !== idPeriode) {
      // Récupération de la période correspondant à l'identifiant reçu en paramètres.
      const periode = this.periodes.find((p) => p.id === idPeriode);

      store.commit(
        modules.utilisateur.mutations.sauvegarderPeriode.name,
        periode
      );

      store.commit(modules.trainProgression.mutations.activerSuivant.name);
    }
  }

  get afficherMessagePeriode(): boolean {
    if (this.periodeSelectionne !== "") {
      // Récupération de la période correspondant à l'identifiant sélectionné
      const periode: Periode | undefined = this.periodes.find(
        (p) => p.id === this.periodeSelectionne
      );

      this.dateDebut = moment(periode?.dateDebut).format("YYYY-MM-DD");
      this.dateFin = moment(periode?.dateFin).format("YYYY-MM-DD");

      return true;
    }

    return false;
  }

  get typeClienteleSelectionne(): TypeClientele | null {
    return store.state.utilisateur.typeClientele;
  }

  get periodes(): Periode[] {
    return store.state.cds.periodes;
  }
}
